































import Vue from "vue";
export default Vue.extend({
  name: "Modal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    centered: {
      type: Boolean,
      required: false,
    },
  },
});
